/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type { TabListContextValues } from '@fluentui/react-components';
import { Overflow } from '@fluentui/react-components';
import { assertSlots, TabListProvider } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type {
  GroundingCommandBarTabListSlots,
  GroundingCommandBarTabListState,
} from './GroundingCommandBarTabList.types';

/**
 * Render the final JSX of GroundingCommandBarTabList
 */
export const renderGroundingCommandBarTabList_unstable = (
  state: GroundingCommandBarTabListState,
  contextValues: TabListContextValues,
): JSXElement => {
  assertSlots<GroundingCommandBarTabListSlots>(state);

  return (
    <Overflow padding={state.overflowPadding} minimumVisible={state.minimumVisible}>
      <state.root>
        <TabListProvider value={contextValues.tabList}>
          {state.root.children}
          {state.overflowMenu && <state.overflowMenu />}
        </TabListProvider>
      </state.root>
    </Overflow>
  );
};
